import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  initialState,
  whatEraWhenYoung,
  whatGenreWhenYoung,
  whatMoodWhenYoung,
} from "../features/listenerProfile";
import EraGenreMoodSelect from "../common/components/EraGenreMoodSelect";
import { useTranslation } from "react-i18next";
import Padding from "../common/components/Padding";
import Center from "../common/components/Center";

const Question1WhatMusicYoung = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [selectedEraValue, setSelectedEraValue] = useState(
    initialState.eraYoung
  );
  const [selectedGenreValue, setSelectedGenreValue] = useState(
    initialState.genreYoung
  );

  const [selectedMoodValue, setSelectedMoodValue] = useState(
    initialState.moodYoung
  );

  useEffect(() => {
    setSelectedGenreValue(0);
  }, [selectedEraValue]);

  useEffect(() => {
    setSelectedMoodValue(0);
  }, [selectedGenreValue]);

  useEffect(() => {
    setSelectedMoodValue(0);
  }, [selectedMoodValue]);

  return (
    <>
      <Padding>
        <Center>
          <h1>{t("Which music did you listen to when you were younger?")}</h1>
        </Center>
      </Padding>
      <Padding>
        <EraGenreMoodSelect
          era={1}
          genre={1}
          mood={1}
          onEraSelect={(eraValue: number) => {
            dispatch(whatEraWhenYoung(eraValue));
            setSelectedEraValue(eraValue);

            const genreSelect = document.getElementById("genre-select");
            if (genreSelect) {
              genreSelect.style.display = "block";
            }
          }}
          onGenreSelect={(genreValue: number) => {
            dispatch(whatGenreWhenYoung(genreValue));
            setSelectedGenreValue(genreValue);

            const moodSelect = document.getElementById("mood-select");
            if (moodSelect) {
              moodSelect.style.display = "block";
            }
          }}
          onMoodSelect={(moodValue: number) => {
            dispatch(whatMoodWhenYoung(moodValue));
            setSelectedGenreValue(moodValue);
          }}
        />
      </Padding>
    </>
  );
};
export default Question1WhatMusicYoung;
